<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <div class="container">
      <div class="logo" @click="goHome">
        <img :src="logoImg" :alt="$t('common.companyName')" class="logo-img">
        <span class="logo-text">{{ $t('common.brandName') }}</span>
      </div>
      
      <!-- PC导航 -->
      <nav class="nav pc-nav">
        <ul>
          <li :class="{ active: $route.name === 'home' }" @click="goHome">{{ $t('nav.home') }}</li>
          <li class="has-dropdown" :class="{ active: isProductActive }">
            <span>
              {{ $t('nav.productCenter') }}
              <svg class="arrow-down" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu dropdown-menu--list">
              <div
                v-for="item in productItems"
                :key="item.id"
                class="dropdown-item"
                :class="{ active: isProductTypeActive(item.type) }"
                @click.stop="goProduct(item.type)"
              >
                <h4>{{ $t('product.' + item.type + '.title') }}</h4>
              </div>
            </div>
          </li>
          <!-- <li :class="{ active: $route.name === 'advantage' }" @click="goAdvantage">{{ $t('nav.advantage') }}</li> -->
          <li class="has-dropdown" :class="{ active: isSolutionActive }">
            <span>
              {{ $t('nav.solution') }}
              <svg class="arrow-down" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu dropdown-menu--list">
              <div
                v-for="item in solutionItems"
                :key="item.id"
                class="dropdown-item"
                :class="{ active: $route.query.type === item.type }"
                @click.stop="goSolution(item.type)"
              >
                <h4>{{ $t('solution.' + item.type + '.title') }}</h4>
              </div>
            </div>
          </li>
          <li :class="{ active: $route.name === 'faq' }" @click="goFaq">{{ $t('nav.faq') }}</li>
          <li :class="{ active: $route.name === 'about' }" @click="goAbout">{{ $t('nav.about') }}</li>
        </ul>
      </nav>
      
      <div class="header-right">
        <button class="header-apply-btn" @click="$scrollToApply">{{ $t('nav.apply') }}</button>
        <div class="lang-switch has-dropdown">
          <span class="lang-current">
            {{ $t('lang.' + $i18n.locale) }}
            <svg class="arrow-down" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
          <div class="dropdown-menu dropdown-menu--lang">
            <div
              v-for="l in ['zh', 'en']"
              :key="l"
              class="dropdown-item dropdown-item--lang"
              :class="{ active: $i18n.locale === l }"
              @click.stop="switchLang(l)"
            >
              <h4>{{ $t('lang.' + l) }}</h4>
            </div>
          </div>
        </div>
        <div class="mobile-menu-btn" @click="mobileNavShow = !mobileNavShow" :class="{ active: mobileNavShow }">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
    
    <!-- 移动端导航 -->
    <transition name="slide-down">
      <div class="mobile-nav" v-show="mobileNavShow">
        <ul>
          <li :class="{ active: $route.name === 'home' }" @click="goHome">{{ $t('nav.home') }}</li>

          <!-- 产品中心分组 -->
          <li class="mobile-group-title" :class="{ open: mobileProductShow, active: isProductActive }" @click="mobileProductShow = !mobileProductShow">
            {{ $t('nav.productCenter') }}
            <svg class="mobile-arrow" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </li>
          <div v-show="mobileProductShow" class="mobile-sub-group">
            <li
              v-for="item in productItems"
              :key="item.id"
              class="mobile-sub-item"
              :class="{ active: isProductTypeActive(item.type) }"
              @click="goProduct(item.type)"
            >
              {{ $t('product.' + item.type + '.title') }}
            </li>
          </div>

          <!-- 解决方案分组 -->
          <li class="mobile-group-title" :class="{ open: mobileSolutionShow, active: isSolutionActive }" @click="mobileSolutionShow = !mobileSolutionShow">
            {{ $t('nav.solutionMobile') }}
            <svg class="mobile-arrow" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </li>
          <div v-show="mobileSolutionShow" class="mobile-sub-group">
            <li
              v-for="item in solutionItems"
              :key="item.id"
              class="mobile-sub-item"
              :class="{ active: $route.query.type === item.type }"
              @click="goSolution(item.type)"
            >
              {{ $t('solution.' + item.type + '.title') }}
            </li>
          </div>

          <li :class="{ active: $route.name === 'faq' }" @click="goFaq">{{ $t('nav.faq') }}</li>
          <li :class="{ active: $route.name === 'about' }" @click="goAbout">{{ $t('nav.about') }}</li>
        </ul>
        <div class="mobile-nav-footer">
          <div class="mobile-lang-switch">
            <div
              v-for="l in ['zh', 'en']"
              :key="l"
              class="mobile-lang-item"
              :class="{ active: $i18n.locale === l }"
              @click="switchLang(l)"
            >
              {{ $t('lang.' + l) }}
            </div>
          </div>
          <button class="mobile-apply-btn" @click="goApply">{{ $t('nav.apply') }}</button>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      mobileNavShow: false,
      mobileSolutionShow: false,
      mobileProductShow: false,
      isScrolled: false,
      logoImg: require('@/assets/logo.png'),
      productItems: [
        { id: 1, type: 'outbound' },
        { id: 2, type: 'inbound' }
      ],
      solutionItems: [
        { id: 1, type: 'car' },
        // { id: 2, type: 'finance' },
        // { id: 3, type: 'education' },
        // { id: 4, type: 'insurance' },
        // { id: 5, type: 'commerce' },
        { id: 6, type: 'government' },
        // { id: 7, type: 'homeDecoration' },
        { id: 8, type: 'law' }
      ]
    }
  },
  computed: {
    isSolutionActive() {
      return this.$route.name === 'solution'
    },
    isProductActive() {
      return this.$route.name === 'productOutbound' || this.$route.name === 'productInbound'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    closeMobileNav() {
      this.mobileNavShow = false
      this.mobileSolutionShow = false
      this.mobileProductShow = false
    },
    goHome() {
      this.closeMobileNav()
      this.$router.push({ name: 'home', params: { lang: this.$i18n.locale } })
    },
    goAdvantage() {
      this.closeMobileNav()
      this.$router.push({ name: 'advantage', params: { lang: this.$i18n.locale } })
    },
    goProduct(type) {
      this.closeMobileNav()
      const name = type === 'inbound' ? 'productInbound' : 'productOutbound'
      this.$router.push({ name, params: { lang: this.$i18n.locale } })
    },
    isProductTypeActive(type) {
      const name = type === 'inbound' ? 'productInbound' : 'productOutbound'
      return this.$route.name === name
    },
    goSolution(type) {
      this.closeMobileNav()
      this.$router.push({ name: 'solution', params: { lang: this.$i18n.locale }, query: { type } })
    },
    goFaq() {
      this.closeMobileNav()
      this.$router.push({ name: 'faq', params: { lang: this.$i18n.locale } })
    },
    goAbout() {
      this.closeMobileNav()
      this.$router.push({ name: 'about', params: { lang: this.$i18n.locale } })
    },
    /* 移动端「申请试用」在汉堡菜单底部：先收起菜单再滚动，
       否则固定定位的菜单面板会挡在申请区块上面 */
    goApply() {
      this.closeMobileNav()
      this.$nextTick(() => this.$scrollToApply())
    },
    switchLang(lang) {
      if (lang === this.$i18n.locale) return
      this.closeMobileNav()
      this.$router.push({ name: this.$route.name, params: { lang }, query: this.$route.query })
    },
    showPopupAndClose() {
      this.mobileNavShow = false
      this.$emit('show-popup')
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: none;
  z-index: 1000;
  transition: all 0.3s ease;
}

.header-scrolled {
  height: 64px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.container {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 var(--container-padding);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.logo:hover {
  transform: translateY(-1px);
}

.logo-img {
  height: 56px;
  width: 70px;
  object-fit: contain;
  transition: height 0.3s ease;
  filter: drop-shadow(0 2px 6px rgba(37, 99, 235, 0.15));
}

.header-scrolled .logo-img {
  height: 48px;
}

.logo-text-wrap {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.logo-text {
  font-size: var(--fs-h3);
  font-weight: 700;
  color: var(--c-navy);
  letter-spacing: 0.5px;
  font-family: var(--font-base);
  white-space: nowrap;
}

.logo-sub {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: var(--c-muted);
  letter-spacing: 0.5px;
  margin-top: 2px;
  font-family: var(--font-base);
}

.pc-nav {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.pc-nav ul {
  display: flex;
  /* gap: 16px; */
}

.pc-nav li {
  padding: 8px 12px;
  font-size: var(--fs-sm);
  font-weight: 500;
  color: var(--c-navy);
  cursor: pointer;
  border-radius: var(--r-sm);
  transition: all 0.3s ease;
  position: relative;
}

.pc-nav li:hover {
  color: var(--c-blue);
  background: transparent;
}

.pc-nav li.active {
  color: var(--c-blue);
  background: transparent;
  border-bottom: 2px solid var(--c-blue);
  border-radius: 0;
}

.has-dropdown {
  position: relative;
}

.has-dropdown:hover {
  color: var(--c-blue) !important;
  background: transparent;
}

.has-dropdown > span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.has-dropdown .arrow-down {
  transition: transform 0.3s ease;
}

.has-dropdown:hover .arrow-down {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--c-white);
  border-radius: var(--r-lg);
  box-shadow: 0 16px 48px rgba(12, 23, 72, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.04);
  padding: 12px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px) scale(0.98);
  transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
  pointer-events: none;
  z-index: 2000;
  margin-top: 10px;
}
.dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 24px;
  width: 10px;
  height: 10px;
  background: var(--c-white);
  transform: rotate(45deg);
}

.dropdown-menu--wide {
  min-width: 840px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.dropdown-menu--list {
  min-width: 260px;
}

.has-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.dropdown-item {
  padding: 12px 14px;
  cursor: pointer;
  border-radius: var(--r-md);
  pointer-events: auto;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: rgba(10, 132, 244, 0.06);
  transform: translateX(2px);
}

.dropdown-item h4 {
  margin: 0 0 6px 0;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--c-text);
}

.dropdown-item p {
  margin: 0;
  font-size: var(--fs-xs);
  color: #718096;
  line-height: 1.5;
}

.dropdown-item.active {
  background-color: rgba(10, 132, 244, 0.08);
}

.dropdown-item.active h4 {
  color: var(--c-blue);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

.lang-switch {
  position: relative;
  display: flex;
  align-items: center;
}

.lang-current {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  font-size: var(--fs-sm);
  font-weight: 500;
  color: var(--c-navy);
  background: #f1f5f9;
  border-radius: var(--r-pill);
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.lang-current:hover {
  background: #e8eef5;
  color: var(--c-blue);
}

.dropdown-menu--lang {
  min-width: 120px;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
}

.has-dropdown:hover .dropdown-menu--lang {
  transform: translateX(-50%) translateY(0);
}

.dropdown-item--lang {
  text-align: center;
}

.dropdown-item--lang h4 {
  margin: 0;
  font-size: var(--fs-sm);
}

.header-apply-btn {
  padding: 10px 24px;
  background: linear-gradient(to right, var(--c-blue) 0%, var(--c-cyan) 100%);
  color: var(--c-white);
  border: none;
  border-radius: 50px;
  font-size: var(--fs-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.header-apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  padding: 8px;
}

.mobile-menu-btn span {
  width: 24px;
  height: 2px;
  background: var(--c-text);
  border-radius: 2px;
  transition: all 0.3s ease;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.mobile-nav {
  display: none;
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  background: #ffffff;
  padding: 16px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-nav ul {
  margin-bottom: 20px;
}

.mobile-nav li {
  padding: 14px 20px;
  font-size: var(--fs-base);
  font-weight: 500;
  color: var(--c-text);
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  border-radius: var(--r-sm);
}

.mobile-nav li:hover,
.mobile-nav li.active {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.05);
}

.mobile-dropdown {
  position: relative;
}

.mobile-dropdown-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  font-size: var(--fs-base);
  font-weight: 500;
  color: var(--c-text);
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  user-select: none;
}

.mobile-dropdown-title:hover {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.05);
}

.mobile-dropdown-title .arrow {
  display: inline-block;
  font-size: var(--fs-h3);
  transition: transform 0.3s ease;
  color: #2563eb;
}

.mobile-dropdown-title .arrow.open {
  transform: rotate(90deg);
}

.mobile-dropdown-list {
  list-style: none;
  margin: 0;
  padding: 0;
  background: rgba(37, 99, 235, 0.03);
}

.mobile-dropdown-list li {
  padding: 12px 20px 12px 40px;
  font-size: var(--fs-sm);
  color: #4a5568;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-dropdown-list li:hover {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
}

.mobile-dropdown-list li.active {
  color: #2563eb;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.1);
  border-left: 3px solid #2563eb;
  padding-left: 37px;
}

/* 一级分组标题 */
.mobile-group-title {
  padding: 16px 20px;
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--c-navy);
  letter-spacing: 0;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 4px;
}
.mobile-group-title.open {
  color: var(--c-blue);
}
.mobile-group-title .mobile-arrow {
  transition: transform 0.3s ease;
}
.mobile-group-title.open .mobile-arrow {
  transform: rotate(180deg);
}
.mobile-sub-group {
  background: rgba(10, 132, 244, 0.03);
}

/* 二级子菜单项 */
.mobile-sub-item {
  padding: 12px 20px 12px 48px;
  font-size: var(--fs-sm);
  color: var(--c-text-2);
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: all 0.3s ease;
}
.mobile-sub-item:hover {
  color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
}
.mobile-sub-item.active {
  color: #2563eb;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.1);
  border-left: 3px solid #2563eb;
  padding-left: 37px;
}

.mobile-nav-footer {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: nowrap;
}
.mobile-lang-switch {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.mobile-lang-item {
  padding: 8px 20px;
  border-radius: 20px;
  background: #f1f5f9;
  font-size: var(--fs-sm);
  cursor: pointer;
  transition: all 0.2s;
}
.mobile-lang-item.active {
  background: var(--c-blue);
  color: #fff;
}
.mobile-apply-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 12px 20px;
  background: linear-gradient(to right, var(--c-blue) 0%, var(--c-cyan) 100%);
  color: var(--c-white);
  border: none;
  border-radius: 50px;
  font-size: var(--fs-base);
  font-weight: 600;
  font-family: var(--font-base);
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

@media (max-width: 1024px) {
  .pc-nav {
    display: none !important;
  }
  .mobile-menu-btn {
    display: flex !important;
  }
  .mobile-nav {
    display: block;
  }
  /* 移动端 Apply 按钮和语言切换都收进汉堡菜单（Apply 在菜单底部），顶栏只留 汉堡 */
  .header-apply-btn,
  .lang-switch {
    display: none;
  }
}

@media (max-width: 768px) {
  .header {
    height: 64px;
  }
  .logo {
    gap: 8px;
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }
  .logo-img {
    height: 40px;
    flex-shrink: 0;
  }
  .logo-text {
    font-size: var(--fs-sm);
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-right {
    flex-shrink: 0;
    gap: 10px;
  }
  .mobile-nav {
    top: 64px;
    max-height: calc(100vh - 64px);
  }
}

@media (max-width: 480px) {
  .logo-text {
    font-size: var(--fs-sm);
  }
  .logo-img {
    height: 35px;
  }
  .lang-current {
    padding: 4px 10px;
    font-size: var(--fs-xs);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/AppHeader.vue